import { gql } from "@apollo/client"

export const ALL_TOURNAMENT_STATUSS = gql`
  query allTournamentStatuss {
    allTournamentStatuss(orderBy: id_ASC) {
      id
      name
      description
    }
  }
`
